export const getAnyCertificado = state => state.hasCertificado;
